<h1 class="title">
  {{ data?.label }}
  {{ 'monitoring.selection' | translate }}
</h1>

<div class="list">
  <div *ngFor="let item of formArray.controls" class="list__item">
    <mat-checkbox
      [formControl]="item.get('isSelected')"
      class="list__item-checkbox"
      [disabled]="item.get('required').value"
      [ngClass]="{ selected: item.get('isSelected').value }"
    >
      <span class="list__item-text" cropText>
        {{ item?.value?.title }}
      </span>
      <ui-svg-icon
        *ngIf="item.get('isSelected').value"
        class="color-success list__item-checkbox-icon list__item-checkbox-icon__checkmark"
        [name]="iconNameList.Checkmark"
      ></ui-svg-icon>
    </mat-checkbox>
  </div>
</div>

<div class="tw-flex tw-justify-between">
  <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
  <ui-action-button
    [action]="buttonAction.Apply"
    [disabled]="!!this.data.maxFieldsCount && selectedFieldsCount > this.data.maxFieldsCount"
    (buttonClick)="apply()"
  ></ui-action-button>
</div>
